import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { Breadcrumb } from '@/components/layout/Breadcrumb'
import { PageHeader } from '@/components/layout/PageHeader'

type ReportCard = {
  id: string
  title: string
  description: string
  to: string
}

/** Reports V1: core reports. Reduced from 7 to 4 true reports per product owner decision. */
export const REPORT_CARDS: ReportCard[] = [
  {
    id: 'inventory-dashboard',
    title: 'Dashboard Quản Trị & Vận Hành Kho',
    description: 'Theo dõi tồn kho, biến động nhập xuất, giữ hàng và chuyển mã.',
    to: '/reports/inventory-dashboard',
  },
  {
    id: 'open-po',
    title: 'PO đang mở & tiến độ giao hàng',
    description: 'Đơn mua đang chờ hàng: đã nhận, còn lại, ngày giao dự kiến, quá hạn.',
    to: '/reports/open-purchase-orders',
  },
  {
    id: 'shortage',
    title: 'Thiếu vật tư',
    description: 'Nhu cầu, tồn, hàng đang về và lượng thiếu theo từng vật tư.',
    to: '/planning/mrp',
  },
  {
    id: 'movements',
    title: 'Sổ cái Nhập / xuất kho',
    description: 'Lịch sử biến động nhập, xuất và chuyển kho theo thời gian.',
    to: '/warehouse/transactions',
  },
  {
    id: 'production-output',
    title: 'Sản lượng 7 công đoạn',
    description: 'Theo dõi sản lượng ngày, tuần, tháng theo công đoạn, chi tiết và lũy kế lệnh.',
    to: '/reports/production-output',
  },
  {
    id: 'packaging-pricing',
    title: 'Báo cáo giá tiền đóng gói',
    description: 'Chi tiết giá tiền vật tư đóng gói theo từng sản phẩm và tổ hợp thuộc tính.',
    to: '/reports/packaging-pricing',
  },
  {
    id: 'product-bom-costs',
    title: 'Chi phí đóng gói & ngũ kim',
    description: 'Tổng tiền đóng gói và ngũ kim theo từng mã hàng / tổ hợp thuộc tính.',
    to: '/reports/product-bom-costs',
  },
]

export function ReportsHubPage(): React.ReactElement {
  return (
    <div>
      <Breadcrumb items={[{ label: 'Trang chủ', to: '/' }, { label: 'Báo cáo' }]} />
      <PageHeader title="Báo cáo" subtitle="Chọn báo cáo cần xem" />
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {REPORT_CARDS.map((card) => (
          <Link
            key={card.id}
            to={card.to}
            data-testid={`report-card-${card.id}`}
            className="group rounded-[var(--radius-lg)] border border-[var(--color-border)] bg-[var(--color-surface)] px-4 py-4 shadow-[var(--shadow-level-1)] transition-colors hover:border-[var(--color-primary)]"
          >
            <div className="flex items-start justify-between gap-2">
              <h2 className="text-base font-semibold text-[var(--color-text)]">{card.title}</h2>
              <ArrowRight className="mt-0.5 h-4 w-4 shrink-0 text-[var(--color-text-muted)] group-hover:text-[var(--color-primary)]" />
            </div>
            <p className="mt-1 text-sm text-[var(--color-text-muted)]">{card.description}</p>
          </Link>
        ))}
      </div>
    </div>
  )
}
